module.exports = __webpack_public_path__ + "static/media/no-user-thumb.dedd7900.svg";